import Base from "./Base"

export default {
  httpBaseUri: "https://dev-api.operandiodev.com",
  httpServiceBaseUri: "https://dev-api.operandiodev.com/graphql",
  wsServiceBaseUri: "wss://dev-api.operandiodev.com/graphql",

  showConfigInTitle: true,
  configTitle: "[LOCALDEV]",

  theme: {
    ...Base.theme,

    logoContainer: "images-dev"
  },

  uploader: {
    ...Base.uploader,

    imageViewerBaseUri: "https://image.operandio.com",
    // imageViewerBucketName: "operandio-content-dev",
    imageViewerBucketName: "operandio-content-ap-southeast-2",

    videoViewerBaseUri: "https://dev-video.operandiodev.com",
    videoViewerBucketName: "dev-operandio-content-ap-southeast-2",

    scormUploadBucketName: "dev-operandio-scorm-quarantine",
    scormViewerBaseUri: "https://dev-scorm.operandiodev.com"
  },

  errors: {
    ...Base.errors,

    showDetail: false,
    showGraphQLErrorNotification: true
  }
}
